import { SearchableField, SearchableFieldType } from '@framework/ui';
import { yup } from '@framework/validation';
import { useMemo } from 'react';

/**
 * Genera dinamicamente lo shape dello schema di validazione dei searchable
 * in base ai valori dei tag semantici recuperati.
 */
export function useSemanticTagSchemaShape(input: {
  searchableFields: SearchableField[];
}) {
  const { searchableFields } = input;

  const shape = useMemo(() => {
    const dynamicSchemaShape: Array<Record<string, yup.AnySchema>> =
      searchableFields.map(field => {
        switch (field.type) {
          case SearchableFieldType.Text:
            return {
              [field.name]: yup.string().allowNullable().label(field.label),
            };
          case SearchableFieldType.Number:
            return {
              [field.name]: yup.number().allowNullable().label(field.label),
            };
          case SearchableFieldType.Date:
            return {
              [field.name]: yup.date().allowNullable().label(field.label),
            };
          case SearchableFieldType.Select:
            return {
              [field.name]: yup
                .string()
                .allowNullable()
                .oneOf([...field.options.map(o => o.value.toString())])
                .label(field.label),
            };

          case SearchableFieldType.NumberRange:
            return {
              [field.from.name]: yup
                .number()
                .allowNullable()
                .label(field.from.label),
              [field.to.name]: yup
                .number()
                .allowNullable()
                .label(field.to.label),
            };

          case SearchableFieldType.DateRange:
            return {
              [field.from.name]: yup
                .date()
                .allowNullable()
                .label(field.from.label),
              [field.to.name]: yup.date().allowNullable().label(field.to.label),
            };
          default:
            return {
              [field.name]: yup.mixed().label(field.label),
            };
        }
      });

    return Object.assign({}, ...dynamicSchemaShape);
  }, [searchableFields]);

  return shape;
}
